import { Box } from '@mui/material';
import { useFormContext } from 'react-hook-form';
import { WsTypography } from 'wisestep-base';

import RecruiterSuggestions from '../../../../../components/filters/components/RecruiterSuggestions';

import { CampaignHeader } from './CampaignHeader';
import { SectionHeaders } from './SectionHeaders';

interface EmailSectionHeaderProps {
  name: string;
  sectionHeader: string;
  sectionSubHeader: string;
  emailType: string;
}

export const EmailSectionHeader = ({
  name,
  sectionHeader,
  sectionSubHeader,
  emailType,
}: EmailSectionHeaderProps) => {
  const { watch } = useFormContext();
  return (
    <Box display="flex" flexDirection="column" rowGap={1.5}>
      <CampaignHeader name={name}>
        <SectionHeaders title={sectionHeader} subTitle={sectionSubHeader} />
      </CampaignHeader>
      <Box width="50%" display="flex" flexDirection="column" rowGap={0.5}>
        <WsTypography>Email Address {watch(name) ? '*' : ''}</WsTypography>
        <RecruiterSuggestions
          name={emailType}
          multiple={false}
          placeholder="Type to add email"
          requireRecruiter={true}
          disableAutoComplete={!watch(name)}
          value={watch(emailType)?.email ?? ''}
        />
      </Box>
    </Box>
  );
};
